import clsx from 'clsx';
import {useState} from 'react';
import styled from 'styled-components';

export interface TextFieldContainerProps {
  error?: string;
  readOnly?: boolean;
  children: (
    isActive: boolean,
    setIsActive: (b: boolean) => void
  ) => React.JSX.Element;
}
export function TextFieldContainer(
  props: TextFieldContainerProps
): React.JSX.Element {
  const [isActive, setIsActive] = useState<boolean>(false);

  return (
    <StyledBorder
      error={props.error}
      isActive={isActive}
      readOnly={props.readOnly}
    >
      {props.children(isActive, setIsActive)}
    </StyledBorder>
  );
}

export const FieldMargin = styled.div`
  margin-bottom: 2rem;
`;

export const SelectContainer = styled(StyledBorder)<{readOnly?: boolean}>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 2em;
  height: 2em;
  padding-top: 0;
  padding-bottom: 0;
  cursor: ${({readOnly}) => (readOnly ? 'default' : 'pointer')};
`;

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isActive: boolean;
  error?: string;
  readOnly?: boolean;
};
function StyledBorder({
  isActive,
  error,
  readOnly,
  className,
  ...props
}: Props): React.JSX.Element {
  const status = readOnly
    ? 'readOnly'
    : error
      ? 'error'
      : isActive
        ? 'active'
        : 'default';

  const cn = clsx(
    className,
    'relative rounded-md border-2 border-solid p-2 outline-hidden',
    status === 'readOnly' && 'border-slate7 bg-slate3',
    status === 'error' && 'border-tomato7 bg-tomato3',
    status === 'active' && 'border-blue7 bg-transparent',
    status === 'default' && 'border-slate7 bg-transparent'
  );

  return <div {...props} className={cn} />;
}
